import { render, staticRenderFns } from "./NewQuestionPlan.vue?vue&type=template&id=49d9f224&scoped=true"
import script from "./NewQuestionPlan.vue?vue&type=script&lang=js"
export * from "./NewQuestionPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d9f224",
  null
  
)

export default component.exports